import gql from "graphql-tag";

export const PUSH_GOOGLE_EVENT_ACTIVITY = gql`
  mutation($input: googlePushActivityInput) {
    pushGoogleActivity(input: $input) {
      title
    }
  }
`;
